import styled from "styled-components/native";
import React from "react";
import { VDBText } from "@components/atoms";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { useTheme } from "styled-components/native";
import RadioButton from "@components/atoms/RadioButton";
import { CardProps, SearchGroupsCardProps } from "./types";
import { View } from "react-native";

import OtherGroups from "./OtherGroups";
import { useTranslation } from "react-i18next";
import { useOrgSettingsSlice } from "@redux/slices/orgSettingsSlice";
import { VDBIcons } from "@utils/VDBIcons";
import { getBoxShadow } from "@utils/product/productValidators";

const SearchGroupCard = ({
  title,
  description,
  checked,
  onPress,
  labelColor,
  expandOtherGroups,
  groupData = [],
  productType,
}: SearchGroupsCardProps) => {
  const typography = useTypographyStore();
  const theme = useTheme();
  const { t } = useTranslation();
  const { isVDBOrg } = useOrgSettingsSlice();

  return (
    <Card
      backgroundColor={checked ? theme["core-01"] : theme["core-02"]}
      borderColor={checked ? labelColor : theme["core-04"]}
    >
      <>
        <Container>
          <CardMain>
            <RadioButton
              label={title}
              checked={checked}
              onPress={onPress}
              labelColor={checked ? theme["core-05"] : theme["core-06"]}
              styles={checked ? typography["H3-M"] : typography["H3-R"]}
              disabled={checked}
              margin="0"
            />
            {checked && isVDBOrg ? (
              <ActiveView>
                <VDBText type={typography["Minor-R"]} color={theme["core-05"]}>
                  {t("searchGroup.active.text")}
                </VDBText>
                <VDBIcon
                  variant={IconsVariant.VDBCustom}
                  name={VDBIcons.CHECK}
                  color={labelColor}
                  size={SpaceType.Big}
                />
              </ActiveView>
            ) : (
              ""
            )}
          </CardMain>
          {description ? (
            <VDBText
              type={checked ? typography["Minor-M"] : typography["Minor-R"]}
              color={checked ? theme["core-05"] : theme["core-06"]}
            >
              {description}
            </VDBText>
          ) : (
            ""
          )}
        </Container>
        {expandOtherGroups && checked && <LineView />}
      </>

      {Array.isArray(groupData) &&
        groupData.some((group) => Object.keys(group).length > 0) &&
        expandOtherGroups &&
        checked && (
          <OtherGroups groupData={groupData} productType={productType} />
        )}
    </Card>
  );
};

const CardMain = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const Container = styled.View`
  margin: ${SpaceType.Double}px;
  gap: ${SpaceType.Basic}px;
`;

const Card = styled(View)<CardProps>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 10px;
  border-color: ${({ borderColor }) => borderColor};
  border-width: 1px;
  margin-top: 10px;
  margin-bottom: 10px;
  box-shadow: ${({ theme }) => getBoxShadow(theme.Shadows.Gentle)};
`;

const LineView = styled.View`
  height: 1px;
  background-color: ${({ theme }) => theme["core-03"]};
`;

const ActiveView = styled.View`
  flex-direction: row;
  align-items: center;
`;

export default SearchGroupCard;
